import {Record} from 'immutable';

const PricingGroupPrice = Record({
    pricingGroupId: '',
    pricing: '',
    period: '',
    price: null, // int
    volume: null, // int
    adhocPrice: null, // int
});

const fromAPI = data => {
    return new PricingGroupPrice({
        pricingGroupId: data.pricingGroupId,
        price: data.price,
        pricing: data.pricing,
        period: data.period,
        volume: data.volume,
        adhocPrice: data.adhocPrice,
    });
};

export default {
    record: PricingGroupPrice,
    default: new PricingGroupPrice(),
    fromAPI,
};
